export default __webpack_public_path__ + "static/mermaid-8118cbfaf081e86db9f28aceb69a7afe.svg";